import React from 'react'
import { LazyLoad } from '../../common/Functions'

function Ecosystem() {
  return (
  <section className="max-w-screen-xl	mx-auto text-center">
    <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
      <div className="w-full flex flex-col justify-center items-center">
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            About the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            Back in 2016, we saw a lot of problems in the healthcare industry in the Philippines - long waiting time, manual booking process, limited access to health services. Our team wanted to create an innovative solution to help Filipinos get the healthcare they need and deserve. Our team started by developing a search engine and an appointment booking system. Today, SeeYouDoc became a comprehensive marketplace, booking, and telehealth platform that allows doctors to conduct online consultations with patients, with electronic medical records, prescriptions, and an e-wallet system.
          </p>
        </div>
        <em className="text-gray-400 mb-10">SeeYouDoc Ecosystem</em>
        <LazyLoad
          alt="Seeyoudoc Eco-system Art"
          src={require('../../common/images/seeyoudoc/syd-ecosystem.png')}
        />
        <div className="content p-20">
          <p className="text-left font-bold text-2xl">
            My Role in the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            I was one of the pioneer members of the start-up company. I started as a junior web designer creating the initial web mockups and front-end development. Then, I was promoted as the Lead UI/UX Designer and learning its roles and responsibilities along the way. Until I became a Product Designer and manage a design team trying to introduce a new approach and improve the existing UI/UX of the product, handles the product roadmap and backlogs, and present design works to multiple departments and different stakeholders for review and feedback.
          </p>
        </div>
        <em className="text-gray-400 mb-10">Patient Web App Mock-ups</em>
        <LazyLoad src={require('../../common/images/seeyoudoc/web-mockup.png')} alt="Seeyoudoc Web Mockup"/>
        <em className="text-gray-400 py-10">Patient Mobile App Mock-ups</em>
        <LazyLoad src={require('../../common/images/seeyoudoc/mobile-mockup.png')} alt="Seeyoudoc Mobile Mockup"/>
      </div>
    </div>
  </section>
  )
}

export default Ecosystem
